import * as firebase from 'firebase';
// eslint-disable-next-line import/no-cycle
import production from '../../access/environment';

const myOtherApp = 'myOtherApp';

const config = production
  ? {
      apiKey: 'AIzaSyCK4q7N7E9RpbnyJeP7NhZpDLaPq5L_Drs',
      authDomain: 'universia-prod.firebaseapp.com',
      databaseURL: 'https://universia-prod.firebaseio.com',
      projectId: 'universia-prod',
      storageBucket: 'universia-prod.appspot.com',
      messagingSenderId: '86519571293',
      appId: '1:86519571293:web:5ccb88d5c9e5c72e05feb4',
      measurementId: 'G-EL6WS1LX6X',
    }
  : {
      apiKey: 'AIzaSyDcXvFUo4d8kLaZ4k330uLpeqiCsR5SMQs',
      authDomain: 'universia-dev.firebaseapp.com',
      databaseURL: 'https://universia-dev.firebaseio.com',
      projectId: 'universia-dev',
      storageBucket: 'universia-dev.appspot.com',
      messagingSenderId: '363063854822',
      appId: '1:363063854822:web:566b9918df10f742ee5d27',
      measurementId: 'G-ZPPECWY6GE',
    };

const secondConfig = production
  ? {
      apiKey: 'AIzaSyAJk36pMtxI9JlyZCmrBZU1NaCDIGEfsmo',
      authDomain: 'lapieza-production.firebaseapp.com',
      databaseURL: 'https://lapieza-production.firebaseio.com',
      projectId: 'lapieza-production',
      storageBucket: 'lapieza-production.appspot.com',
      messagingSenderId: '781662415856',
      appId: '1:781662415856:web:51f8695fe9ca0a0f',
    }
  : {
      apiKey: 'AIzaSyAjQjrBMB73R5afENREDa0En7MnZpewQZ0',
      authDomain: 'pieza-development.firebaseapp.com',
      databaseURL: 'https://pieza-development.firebaseio.com',
      projectId: 'pieza-development',
      storageBucket: 'pieza-development.appspot.com',
      messagingSenderId: '10560275828',
      appId: '1:10560275828:web:e7979f61272aaca7cd9821',
    };

firebase.initializeApp(config);
firebase.initializeApp(secondConfig, myOtherApp);
const database = firebase.firestore();
const secondDatabase = firebase.app(myOtherApp).firestore();
const seconStorage = firebase.app(myOtherApp).storage();
const storage = firebase.storage();

export { firebase, storage, secondDatabase, seconStorage, database as default };
